import React from 'react';
import { Quote } from '../types';
import Icon from '../../../components/AppIcon';

interface QuickStatsCardsProps {
  quotes: Quote[];
}

const QuickStatsCards: React.FC<QuickStatsCardsProps> = ({ quotes }) => {
  const stats = {
    total: quotes.length,
    open: quotes.filter((q) => q.status === 'OPEN').length,
    approved: quotes.filter((q) => q.status === 'APPROVED').length,
    totalValue: quotes.reduce((sum, q) => sum + q.totalValue, 0),
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-EU', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const cards = [
    {
      label: 'Total Quotes',
      value: stats.total,
      icon: 'FileText',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      label: 'Open Quotes',
      value: stats.open,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      label: 'Approved',
      value: stats.approved,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      label: 'Total Value',
      value: formatCurrency(stats.totalValue),
      icon: 'TrendingUp',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${card.bgColor}`}>
              <Icon name={card.icon} size={24} className={card.color} />
            </div>
          </div>
          <p className="text-sm text-text-secondary mb-1">{card.label}</p>
          <p className="text-2xl font-semibold text-text-primary">{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsCards;